export const FEATURE_STATIC_PASSAGE_REFERENCE_MIGRATION = 'static-passage-reference-migration';
// Access = show Calendar. Empty access_ids → Calendar hidden (default).
export const FEATURE_SHOW_CALENDAR = 'show-calendar';
